import React from 'react';
import { Alert, Text, Button, Flex, Link } from '@chakra-ui/react';
import { useEnvironment } from '#core/Environment';

const SupportMessageInProduct: React.FC<{ productName: string }> = ({
  productName,
}) => {
  const { classicUrl } = useEnvironment();

  return (
    <Flex w="100%" h="90vh" justifyContent="center" alignItems="center">
      <Alert
        status="warning"
        borderColor="orange.400"
        borderWidth={1}
        borderStyle="solid"
        borderRadius={6}
        maxW={400}
      >
        <Flex justifyContent="center" alignItems="center" flexFlow="column">
          <Text>
            We are working hard to create a single platform which will enhance
            your experience with us.{' '}
          </Text>
          <Text my={20}>
            Our technical team is preparing for the {productName} to be moved
            onto the single platform, which will make your browsing experience,
            simple.
          </Text>
          <Button mb={25} colorScheme="yellow" variant="solid">
            <Link isExternal href={classicUrl}>
              ACCESS NOW
            </Link>
          </Button>
        </Flex>
      </Alert>
    </Flex>
  );
};

export default SupportMessageInProduct;
